/// <amd-module name="Build/Admin/Common/Actions/ProjectActions" />
import { Action } from "VSS/Reflux/Action";

import { ITeamProject } from "TFS/Services/TfsProjectService";

export class ProjectActions {
    public projectsUpdated = new Action<ITeamProject[]>();
}
